import { useState } from 'react';
import { connect } from 'react-redux';
import Tab from 'react-bootstrap/Tab';
import Nav from 'react-bootstrap/Nav';
import { toastr } from 'react-redux-toastr';

import { useParams } from 'react-router-dom';
import * as actions from './store/actions';
import { useComponentDidMount, useComponentWillUnmount } from '../core/hooks';
import FormPage from '../core/containers/FormPage';
import ClientPersonalInfo from './ClientPersonalInfo';
import Can from '../permissions/abilities/Can';
import APPConf from '../../lib/config/common';
import ClientContacts from './ClientContacts';
import { clientEditValidationSchema } from './validation';
import ClientVehicles from './ClientVehicles';
import ClientDocs from './ClientDocs';
import NotificationsHistory from './NotificationsHistory';
import ClientOrders from './ClientOrders';
import Client1COrders from './Client1COrders';
import InsuranceLosses from './InsuranceLosses';
import ServiceCards from './ServiceCards';
import BonusHistory from './BonusHistory';
import ClientPromoList from '../promos/main/ClientPromoList';
import ClientVezemKolesa from './ClientVezemKolesa';
import ClientActivity from './ClientActivity';
// import ClientInsurancePanel from './ClientInsurancePanel';
import moment from 'moment';

// interface ClientPageProps {
//   data?: object
//   getClient?(...args: unknown[]): unknown
//   updateClient?(...args: unknown[]): unknown
//   clearClientData?(...args: unknown[]): unknown
// }

const ClientPage = props => {
  const {
    data,
    getClient,
    updateClient,
    clearClientData,
  } = props;

  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState('personal'); // тут будем фиксировать активный таб, чтобы при рендере лишние Табы не дергать

  const loadData = async id => {
    if ((id) && (data?.id !== id)) {
      setLoading(true);
      getClient(id);
      setLoading(false);
    }
  };

  const handleSubmit = async (values, form) => {
    setLoading(true);

    try {
      // await updateClient(values);
      await updateClient({
        ...values, 
        testClientMarkedAt: values?.testClientMarkedAtBool 
          ? (values?.testClientMarkedAt ?? moment.utc().unix() ) : null, 
      });
      toastr.success(APPConf.successHdr, APPConf.successSaveMsg);
    } catch (error) {
      toastr.error(APPConf.errorHdr, error.message || error);
    } finally {
      form.setSubmitting(false);
    }

    setLoading(false);
  };

  const params = useParams();
  const clientId = params?.id;

  useComponentDidMount(() => {
    loadData(clientId);
  });

  useComponentWillUnmount(() => {
    clearClientData();
  });

  return (
    <FormPage
      header='Просмотр клиента'
      initialValues={ { ...data, testClientMarkedAtBool: data?.testClientMarkedAt ? true : false } }
      validationSchema={ clientEditValidationSchema }
      onSubmit={ handleSubmit }
      loading={ loading }
      redSubmitButtonIfError={ true }
    >
      <Tab.Container
        defaultActiveKey='personal'
        id='client-tabs'
        onSelect={ (firstTab) => {
          setActiveTab(firstTab);
        } }
      >
        <Nav className='nav-tabs'>
          <Can on='reference.person.card.personal.data'>
            <Nav.Item>
              <Nav.Link eventKey='personal'>Личные данные</Nav.Link>
            </Nav.Item>
          </Can>
          <Can on='reference.person.card.contact.detail'>
            <Nav.Item>
              <Nav.Link eventKey='contact'>Контактные данные</Nav.Link>
            </Nav.Item>
          </Can>
          <Nav.Item>
            <Nav.Link eventKey='vehicle'>Автомобили</Nav.Link>
          </Nav.Item>
          { /* <Nav.Item>
            <Nav.Link eventKey='client_insurances'>Страховки (полный список)</Nav.Link>
          </Nav.Item> */ }
          <Nav.Item>
            <Nav.Link eventKey='docs'>Документы</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey='orders'>Заявки</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey='orders1c'>Заказы из 1С</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey='notifications'>История уведомлений</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey='insurance_losses'>Убытки клиента</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey='insurance_service_cards'>Сервисные карты</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey='bonus'>Бонусы</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey='promo'>Промоакции</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey='vehicleV2'>Страхование</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey='vezemKolesa'>Везём Колёса</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey='activity'>Активность клиента</Nav.Link>
          </Nav.Item>
        </Nav>

        <Tab.Content>
          <Tab.Pane eventKey='personal'>
            <ClientPersonalInfo clientId={ clientId } />
          </Tab.Pane>
          <Tab.Pane eventKey='contact'>
            <ClientContacts />
          </Tab.Pane>
          <Tab.Pane eventKey='vehicle'>
            { (activeTab === 'vehicle')
            && (<ClientVehicles clientId={ clientId } />) }
          </Tab.Pane>
          <Tab.Pane eventKey='docs'>
            <ClientDocs />
          </Tab.Pane>
          <Tab.Pane eventKey='orders'>
            { (activeTab === 'orders')
            && (<ClientOrders clientId={ clientId } />) }
          </Tab.Pane>
          <Tab.Pane eventKey='orders1c'>
            { (activeTab === 'orders1c')
            && (<Client1COrders clientId={ clientId } />) }
          </Tab.Pane>
          <Tab.Pane eventKey='notifications'>
            { (activeTab === 'notifications')
            && (<NotificationsHistory clientId={ clientId } />) }
          </Tab.Pane>
          <Tab.Pane eventKey='insurance_losses'>
            { (activeTab === 'insurance_losses')
            && (<InsuranceLosses clientId={ clientId } />) }
          </Tab.Pane>
          <Tab.Pane eventKey='insurance_service_cards'>
            { (activeTab === 'insurance_service_cards')
            && (<ServiceCards clientId={ clientId } />) }
          </Tab.Pane>
          <Tab.Pane eventKey='bonus'>
            { (activeTab === 'bonus')
            && (<BonusHistory clientId={ clientId } />) }
          </Tab.Pane>
          <Tab.Pane eventKey='promo'>
            { (activeTab === 'promo')
            && (<ClientPromoList clientId={ clientId } />) }
          </Tab.Pane>
          { /* <Tab.Pane eventKey='client_insurances'>
            { (activeTab === 'client_insurances')
            && (<ClientInsurancePanel clientId={ clientId } />) }
          </Tab.Pane> */ }
          <Tab.Pane eventKey='vehicleV2'>
            { (activeTab === 'vehicleV2')
            && (<ClientVehicles 
              clientId={ clientId }
              onlyShowInsurance
            />) }
          </Tab.Pane>
          <Tab.Pane eventKey='vezemKolesa'>
            <ClientVezemKolesa clientId={ clientId } />
          </Tab.Pane>
          <Tab.Pane eventKey='activity'>
            { (activeTab === 'activity')
            && (<ClientActivity clientId={ clientId } />) }
          </Tab.Pane>
        </Tab.Content>

      </Tab.Container>
    </FormPage>
  );
};

const mapStateToProps = state => ({
  data: state.clients?.item,
});

const mapDispatchToProps = {
  getClient: actions.getClientInfo,
  updateClient: actions.updateClient,
  clearClientData: actions.clearClientData,
};

export default connect(mapStateToProps, mapDispatchToProps)(ClientPage);
